import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import FormNewUser from '../../containers/FormNewUser'
import EditableTableUsers from '../../containers/EditableTableUsers'
import * as Constants from '../../../constants'
import { db, cloudFunctions } from '../../../config/Fire'
import LoadingPage from '../../components/LoadingPage'
import { Divider, Button, message, Modal, List, Spin } from 'antd'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'
import Search from 'antd/lib/input/Search'
import { getUser } from '../../../reducers'
import './styles.css'

const usersRef = db.ref(`${Constants.MAIN_NODES.USERS}`)

function compareName(a, b) {
    // Validar que ambos objetos existan
    if (!a && !b) return 0
    if (!a) return 1
    if (!b) return -1

    // Validar que name exista y sea string, con conversión segura
    let nameA = ''
    let nameB = ''

    if (a && a.name != null) {
        nameA = String(a.name).toLowerCase()
    }
    if (b && b.name != null) {
        nameB = String(b.name).toLowerCase()
    }

    if (nameA < nameB) {
        return -1
    }
    if (nameA > nameB) {
        return 1
    }
    return 0
}

/** Translates common Firebase Auth error messages to Spanish */
function translateFirebaseError(msg) {
    if (!msg) return 'Error desconocido al crear el usuario'
    const msgStr = String(msg)
    if (msgStr.includes('already in use') || msgStr.includes('already exists') || msgStr.includes('EMAIL_EXISTS')) {
        return 'El correo electrónico ya está en uso por otra cuenta.'
    }
    if (msgStr.includes('badly formatted') || msgStr.includes('invalid email') || msgStr.includes('INVALID_EMAIL')) {
        return 'El formato del correo electrónico es inválido.'
    }
    if (msgStr.includes('password must be')) {
        return 'La contraseña no cumple con los requisitos mínimos de seguridad.'
    }
    return msgStr
}

/** Reverse-lookup: label (lowercase) -> DB key for OPERATOR_CATEGORIES */
const CATEGORY_LABEL_TO_KEY = {
	'ayudante': 'HELPER',
	'medio oficial': 'HALF_OFFICIAL',
	'oficial': 'OFFICIAL',
	'oficial especializado': 'SPECIALIZED_OFFICIAL'
}

class Users extends Component {
    state = {
        usersMap: null,
        usersFiltered: null,
        tableCurrentData: null,
        importLoading: false,
        importErrors: [],
        showErrorModal: false
    }

    getData = () => {
        usersRef.on('value', (usersSnap) => {
            const usersLoaded = {}
            if (usersSnap.exists() && usersSnap.val() !== null) {
                usersSnap.forEach(userSnap => {
                    const user = userSnap.val()
                    // Solo mostrar usuarios de tipo CONSTRUCTION (Obra)
                    if (user && user.userType && user.id && user.userType === 'CONSTRUCTION') {
                        usersLoaded[user.id] = user
                    }
                })
            }
            if (this.searchInput && this.searchInput.input && this.searchInput.input.state) {
                this.searchInput.input.state.value = ''
            }
            // Inicializar usersFiltered con los usuarios cargados para evitar llamar searchUser en el render
            const usersArray = Object.keys(usersLoaded)
                .map(key => usersLoaded[key])
                .filter(user => user != null && user.name != null && user.name !== undefined)
            usersArray.sort(compareName)
            
            this.setState((prevState) => {
                let newTableCurrentData = prevState.tableCurrentData;
                if (newTableCurrentData) {
                    newTableCurrentData = newTableCurrentData.map(item => usersLoaded[item.id]).filter(Boolean);
                }
                return { usersMap: usersLoaded, usersFiltered: usersArray, tableCurrentData: newTableCurrentData }
            })
        })
        return (<LoadingPage />)
    }

    componentWillUnmount() {
        usersRef.off('value')
    }

    renderUsersTable = usersFiltered => {
        var data = []
        // Manejar tanto arrays como objetos
        const usersArray = Array.isArray(usersFiltered)
            ? usersFiltered
            : Object.keys(usersFiltered).map(userKey => usersFiltered[userKey])

        usersArray.forEach(user => {
            if (user && user.name != null) {
                data.push({
                    ...user,
                    id: user.id,
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    dni: user.dni || '',
                    userType: Constants.userTypesMap[user.userType],
                    createDate: user.createDate,
                    enabled: user.enabled
                })
            }
        })
        // Filtrar elementos inválidos antes de ordenar
        data = data.filter(item => item != null && item.name != null)
        data.sort(compareName)
        return (<EditableTableUsers
            data={data}
            hideUserTypeFilter={true}
            hidePhoneIcon={true}
            hideUserTypeColumn={true}
            showDniColumn={true}
            showEditButton={true}
            onTableChange={this.handleTableChange}
        />)
    }

    handleTableChange = (currentData) => {
        this.setState({ tableCurrentData: currentData })
    }

    exportToExcel = async () => {
        const { usersFiltered, tableCurrentData } = this.state
        const sourceData = tableCurrentData || usersFiltered

        if (!sourceData || (Array.isArray(sourceData) && sourceData.length === 0)) {
            message.warning('No hay datos para exportar')
            return
        }

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Usuarios')

        const COLUMN_HEADERS = [
            { header: 'Nombre', key: 'name', width: 30 },
            { header: 'Correo Electrónico', key: 'email', width: 50 },
            { header: 'DNI', key: 'dni', width: 15 },
            { header: 'Categoría', key: 'category', width: 20 },
            { header: 'Multiples registros', key: 'enableMultipleRecords', width: 20 },
            { header: 'Teléfono de emergencia', key: 'emergencyPhone', width: 30 },
			{ header: 'Referencia de emergencia', key: 'emergencyContactReference', width: 30 },
            { header: 'Domicilio Real', key: 'realAddress', width: 30 },
			{ header: 'Pertenece a', key: 'isSadeEmployee', width: 25 },
            { header: 'Habilitado', key: 'enabled', width: 15 },
            { header: 'Registro', key: 'createDate', width: 20 },
        ]

        worksheet.columns = COLUMN_HEADERS

        const HEADER_FILL = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF263238' } }
        const HEADER_FONT = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 }
        const HEADER_ALIGNMENT = { horizontal: 'center', vertical: 'middle' }
        const HEADER_BORDER = {
            top: { style: 'thin', color: { argb: 'FF455A64' } },
            bottom: { style: 'medium', color: { argb: 'FF455A64' } },
            left: { style: 'thin', color: { argb: 'FF455A64' } },
            right: { style: 'thin', color: { argb: 'FF455A64' } }
        }

        const headerRow = worksheet.getRow(1)
        headerRow.height = 22
        headerRow.eachCell(cell => {
            cell.fill = HEADER_FILL
            cell.font = HEADER_FONT
            cell.alignment = HEADER_ALIGNMENT
            cell.border = HEADER_BORDER
        })

        const NORMAL_FILL = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
        const NORMAL_BORDER = {
            top: { style: 'hair', color: { argb: 'FFD0D0D0' } },
            bottom: { style: 'hair', color: { argb: 'FFD0D0D0' } },
            left: { style: 'hair', color: { argb: 'FFD0D0D0' } },
            right: { style: 'hair', color: { argb: 'FFD0D0D0' } }
        }

		const usersArray = Array.isArray(sourceData)
			? sourceData
			: Object.keys(sourceData).map(userKey => sourceData[userKey])

		let data = usersArray.filter(item => item != null && item.name != null && item.enabled !== false)
		if (!tableCurrentData) {
			data.sort(compareName)
		}

        data.forEach(user => {
            let dateFormatted = '--'
            if (user.createDate) {
                // Format exactly as in EditableTableUsers
                dateFormatted = moment(user.createDate, "DD/MM/YYYY HH:mm").format("HH:mm DD/MM/YYYY")
                if (dateFormatted === 'Invalid date') {
                    // Fallback to simple moment parse in case it's a timestamp and the explicit format failed
                    dateFormatted = moment(user.createDate).format("HH:mm DD/MM/YYYY")
                }
            }

            const catLabel = (user.category && Constants.OPERATOR_CATEGORIES && Constants.OPERATOR_CATEGORIES[user.category]) 
                ? Constants.OPERATOR_CATEGORIES[user.category] 
                : '--'

			let perteneceA = 'Grupo SADE'
			const isSade = user.isSadeEmployee === true || String(user.isSadeEmployee).toUpperCase() === 'SI' || String(user.isSadeEmployee).toLowerCase() === 'true'
			if (!isSade) {
				perteneceA = user.contractor || '-'
			}

            const row = worksheet.addRow({
                name: user.name || '--',
                email: user.email || '--',
                dni: user.dni || '--',
                category: catLabel,
                enableMultipleRecords: user.enableMultipleRecords ? 'SI' : 'NO',
                emergencyPhone: user.emergencyPhone || '-',
				emergencyContactReference: user.emergencyContactReference || '-',
                realAddress: user.realAddress || '-',
				isSadeEmployee: perteneceA,
                enabled: user.enabled !== false ? 'Sí' : 'No',
                createDate: dateFormatted
            })

            row.eachCell((cell, colNumber) => {
                cell.fill = NORMAL_FILL
                cell.border = NORMAL_BORDER
                
                const colKey = worksheet.getColumn(colNumber).key
                if (['enableMultipleRecords', 'isSadeEmployee', 'enabled'].includes(colKey)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' }
                } else if (colKey === 'dni') {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' }
                } else {
                    cell.alignment = { vertical: 'middle' }
                }
            })
        })

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        
        const dateObj = new Date()
        const dateStr = `${String(dateObj.getDate()).padStart(2, '0')}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${dateObj.getFullYear()}`
        
        saveAs(blob, `Usuarios_${dateStr}.xlsx`)
        message.success('Excel descargado exitosamente')
    }

    /** Generates and downloads the import template with dropdowns and instructions sheet */
    downloadTemplate = async () => {
        try {
            const contractorsSnap = await db.ref('contractors').once('value')
            const contractors = contractorsSnap.exists() ? (contractorsSnap.val() || []) : []
            const perteneceAList = ['Grupo SADE', ...contractors]

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Importar Empleados')

            worksheet.columns = [
                { header: 'Nombre', key: 'name', width: 30 },
                { header: 'DNI', key: 'dni', width: 15 },
                { header: 'Correo Electrónico', key: 'email', width: 35 },
                { header: 'Categoría', key: 'category', width: 25 },
                { header: 'Pertenece a', key: 'perteneceA', width: 25 },
                { header: 'Multiples registros', key: 'multipleRecords', width: 22 },
                { header: 'Habilitado', key: 'enabled', width: 15 },
                { header: 'Teléfono de emergencia', key: 'emergencyPhone', width: 25 },
				{ header: 'Referencia de emergencia', key: 'emergencyContactReference', width: 25 },
                { header: 'Domicilio real', key: 'realAddress', width: 35 },
            ]

            const headerRow = worksheet.getRow(1)
            headerRow.height = 25
            headerRow.eachCell(cell => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF263238' } }
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 }
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
            })

            const CATEGORIES = Object.values(Constants.OPERATOR_CATEGORIES)
            const YES_NO = ['SI', 'NO']

            for (let i = 2; i <= 500; i++) {
                worksheet.getCell(i, 4).dataValidation = {
                    type: 'list', allowBlank: true,
                    formulae: [`"${CATEGORIES.join(',')}"`],
                    showErrorMessage: true, errorTitle: 'Valor inválido',
                    error: `Valores permitidos: ${CATEGORIES.join(', ')}`
                }
                worksheet.getCell(i, 5).dataValidation = {
                    type: 'list', allowBlank: true,
                    formulae: [`"${perteneceAList.join(',')}"`],
                    showErrorMessage: true, errorTitle: 'Valor inválido',
                    error: 'Seleccione Grupo SADE o un contratista de la lista.'
                }
                worksheet.getCell(i, 6).dataValidation = {
                    type: 'list', allowBlank: true,
                    formulae: [`"${YES_NO.join(',')}"`],
                    showErrorMessage: true, errorTitle: 'Valor inválido', error: 'Ingrese SI o NO.'
                }
                worksheet.getCell(i, 7).dataValidation = {
                    type: 'list', allowBlank: true,
                    formulae: [`"${YES_NO.join(',')}"`],
                    showErrorMessage: true, errorTitle: 'Valor inválido', error: 'Ingrese SI o NO.'
                }
            }

            // Instructions sheet
            const wsHelp = workbook.addWorksheet('Instrucciones y Referencias')
            wsHelp.columns = [{ width: 25 }, { width: 18 }, { width: 75 }]
            wsHelp.addRow(['Columna', 'Obligatorio', 'Descripción / Reglas'])
            const helpHeaderRow = wsHelp.getRow(1)
            helpHeaderRow.height = 25
            helpHeaderRow.eachCell(cell => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1565C0' } }
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 }
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
            })
            const helpRows = [
                ['Nombre', 'SI', 'Nombre completo del empleado (Ej: Juan Pérez).'],
                ['DNI', 'SI', 'Número de documento sin puntos ni espacios. Se usa para determinar si el empleado ya existe.'],
                ['Correo Electrónico', 'SI (solo nuevos)', 'Requerido si el DNI no está registrado. Se usa para la cuenta de acceso. Se ignora en actualizaciones.'],
                ['Categoría', 'SI', `Puesto del operario. Valores válidos: ${CATEGORIES.join(', ')}.`],
                ['Pertenece a', 'SI', `Escribir "Grupo SADE" para empleados directos, o el nombre exacto del contratista. Contratistas actuales: ${contractors.join(', ') || '(ninguno)'}.`],
                ['Multiples registros', 'NO', 'SI si puede registrar asistencia más de una vez por día. Default: NO.'],
                ['Habilitado', 'NO', 'SI para usuario activo, NO para desactivarlo. Default: SI.'],
                ['Teléfono de emergencia', 'NO', 'Teléfono de contacto en caso de accidentes.'],
				['Referencia de emergencia', 'NO', 'Referencia del contacto de emergencia.'],
                ['Domicilio real', 'NO', 'Dirección física del empleado.'],
            ]
            helpRows.forEach((r, idx) => {
                wsHelp.addRow(r)
                wsHelp.getCell(`A${idx + 2}`).font = { bold: true }
                wsHelp.getCell(`B${idx + 2}`).alignment = { horizontal: 'center' }
                wsHelp.getCell(`C${idx + 2}`).alignment = { wrapText: true, vertical: 'top' }
            })

            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const d = new Date()
            const dateStr = `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`
            saveAs(blob, `Plantilla_Importacion_${dateStr}.xlsx`)
            message.success('Plantilla descargada exitosamente')
        } catch (err) {
            console.error('Error generating template:', err)
            message.error('Error al generar la plantilla.')
        }
    }

    /** Processes the uploaded Excel file row by row */
    importFromExcel = async (file) => {
        if (!file) return
        this.setState({ importLoading: true, importErrors: [], showErrorModal: false })
        const errors = []

        try {
            const contractorsSnap = await db.ref('contractors').once('value')
            const contractors = contractorsSnap.exists() ? (contractorsSnap.val() || []) : []
            const contractorsLower = contractors.map(c => String(c).toLowerCase())

            const { usersMap } = this.state
            const dniToUser = {}
            if (usersMap) {
                Object.values(usersMap).forEach(user => {
                    if (user && user.dni != null) dniToUser[parseInt(user.dni)] = user
                })
            }

            const buffer = await file.arrayBuffer()
            const workbook = new ExcelJS.Workbook()
            await workbook.xlsx.load(buffer)

            const worksheet = workbook.getWorksheet('Importar Empleados') || workbook.worksheets[0]
            if (!worksheet) {
                message.error('El archivo no contiene una hoja válida.')
                this.setState({ importLoading: false })
                return
            }

            const headerRow = worksheet.getRow(1)
            const columnMap = {}
            headerRow.eachCell((cell, colNumber) => {
                const header = String(cell.value || '').trim()
                if (header) columnMap[header] = colNumber
            })

            const getCell = (row, headerName) => {
                const col = columnMap[headerName]
                if (!col) return ''
                const v = row.getCell(col).value
                return v === null || v === undefined ? '' : String(v).trim()
            }

            const rows = []
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return
                rows.push(row)
            })

            const CONCURRENCY_LIMIT = 10
            for (let i = 0; i < rows.length; i += CONCURRENCY_LIMIT) {
                const chunk = rows.slice(i, i + CONCURRENCY_LIMIT)
                await Promise.allSettled(
                    chunk.map(row => this._processImportRow(getCell, row, dniToUser, contractorsLower, errors))
                )
            }
        } catch (err) {
            console.error('Import error:', err)
            message.error('Error al leer el archivo. Verifique que sea un Excel válido.')
        }

        this.setState({ importLoading: false, importErrors: errors })
        if (errors.length > 0) {
            this.setState({ showErrorModal: true })
        } else {
            message.success('¡Importación completada exitosamente!')
        }
        if (this.fileInput) this.fileInput.value = ''
    }

    /** Validates and persists a single Excel row (create or update by DNI) */
    _processImportRow = async (getCell, row, dniToUser, contractorsLower, errors) => {
        const name = getCell(row, 'Nombre')
        const dniRaw = getCell(row, 'DNI')
        const email = getCell(row, 'Correo Electrónico')
        const categoryLabel = getCell(row, 'Categoría')
        const perteneceA = getCell(row, 'Pertenece a')
        const multipleRecordsRaw = getCell(row, 'Multiples registros')
        const enabledRaw = getCell(row, 'Habilitado')
        const emergencyPhone = getCell(row, 'Teléfono de emergencia')
		const emergencyContactReference = getCell(row, 'Referencia de emergencia')
        const realAddress = getCell(row, 'Domicilio real')

        // Skip entirely blank rows
        if (!name && !dniRaw && !email && !categoryLabel && !perteneceA) return

        const displayDni = dniRaw || '(sin DNI)'

        if (!name) {
            errors.push({ name: '(sin nombre)', dni: displayDni, reason: 'Falta el campo obligatorio: Nombre' })
            return
        }

        const dniNumber = parseInt(String(dniRaw).replace(/\D/g, ''))
        if (!dniRaw || isNaN(dniNumber)) {
            errors.push({ name, dni: displayDni, reason: 'DNI inválido o vacío' })
            return
        }

        if (!categoryLabel) {
            errors.push({ name, dni: dniRaw, reason: 'Falta el campo obligatorio: Categoría' })
            return
        }
        const categoryKey = CATEGORY_LABEL_TO_KEY[categoryLabel.toLowerCase()]
        if (!categoryKey) {
            errors.push({ name, dni: dniRaw, reason: `Categoría inválida: "${categoryLabel}". Valores permitidos: ${Object.values(Constants.OPERATOR_CATEGORIES).join(', ')}` })
            return
        }

        if (!perteneceA) {
            errors.push({ name, dni: dniRaw, reason: 'Falta el campo obligatorio: Pertenece a' })
            return
        }

        let isSadeEmployee = false
        let contractor = null
        if (perteneceA.toLowerCase() === 'grupo sade') {
            isSadeEmployee = true
        } else {
            if (!contractorsLower.includes(perteneceA.toLowerCase())) {
                errors.push({ name, dni: dniRaw, reason: `El contratista "${perteneceA}" no está registrado en el sistema` })
                return
            }
            contractor = perteneceA
        }

        const enableMultipleRecords = multipleRecordsRaw.toUpperCase() === 'SI'
        const enabled = enabledRaw === '' ? true : enabledRaw.toUpperCase() !== 'NO'
        const existingUser = dniToUser[dniNumber]

        try {
            if (existingUser) {
                const updates = { name, category: categoryKey, isSadeEmployee, contractor, enableMultipleRecords, enabled }
                if (emergencyPhone) updates.emergencyPhone = emergencyPhone
				if (emergencyContactReference) updates.emergencyContactReference = emergencyContactReference
                if (realAddress) updates.realAddress = realAddress
                await db.ref(`${Constants.MAIN_NODES.USERS}/${existingUser.id}`).update(updates)
            } else {
                if (!email) {
                    errors.push({ name, dni: dniRaw, reason: 'El correo electrónico es obligatorio para nuevos usuarios' })
                    return
                }
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(email)) {
                    errors.push({ name, dni: dniRaw, reason: `Correo electrónico inválido: "${email}"` })
                    return
                }
                const createData = {
                    name, email, password: 'gruposade', userType: 'CONSTRUCTION',
                    employeeCategories: {}, companiesIds: {}, dni: dniNumber,
                    category: categoryKey, enableMultipleRecords, isSadeEmployee, contractor, enabled
                }
                if (emergencyPhone) createData.emergencyPhone = emergencyPhone
				if (emergencyContactReference) createData.emergencyContactReference = emergencyContactReference
                if (realAddress) createData.realAddress = realAddress

                const response = await cloudFunctions.createUser(createData)
                if (!response || !response.data || response.data.code !== 0) {
                    const rawReason = response?.data?.error?.errorInfo?.message || response?.data?.message || 'Error desconocido al crear el usuario'
                    errors.push({ name, dni: dniRaw, reason: translateFirebaseError(rawReason) })
                }
            }
        } catch (err) {
            errors.push({ name, dni: dniRaw, reason: translateFirebaseError(err.message) })
        }
    }

    searchUser = (value) => {

        const { usersMap } = this.state
        if (usersMap) {
            var usersData = []
            for (var key in usersMap) {
                const user = usersMap[key]
                // Filtrar usuarios válidos con name definido
                if (user && user.name != null && user.name !== undefined) {
                    if (value === '' ||
                        (user.name && String(user.name).toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
                        (user.email && user.email && String(user.email).toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
                        (user.dni && String(user.dni).toLowerCase().indexOf(value.toLowerCase()) !== -1)) {
                        usersData.push(user)
                    }
                }
            }
            // Filtrar cualquier elemento null/undefined antes de ordenar
            usersData = usersData.filter(user => user != null && user.name != null)
            usersData.sort(compareName)
            this.setState({ usersFiltered: usersData, tableCurrentData: null })
        }
    }

    render() {
        const { usersMap, usersFiltered, importLoading, importErrors, showErrorModal } = this.state
        return (
            <div>
                {importLoading && (
                    <div style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.55)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        gap: '16px',
                        zIndex: 9999,
                        pointerEvents: 'all'
                    }}>
                        <Spin size="large" />
                        <span style={{ color: '#fff', fontSize: '16px', fontWeight: 500 }}>
                            Procesando importación...
                        </span>
                    </div>
                )}
                {
                    usersMap ?
                        <Grid className="usersCont">
                            <Divider>Nuevo usuario</Divider>
                            <Row center="xs">
                                <Col xs={12}>
                                    <FormNewUser
                                        allowedUserTypes={['CONSTRUCTION']}
                                        defaultUserType="CONSTRUCTION"
                                        showDniField={true}
                                        constructionUsers={Object.values(usersMap)}
                                    />
                                </Col>
                            </Row>
                            <Divider>Usuarios</Divider>
                            <input
                                type="file"
                                accept=".xlsx"
                                style={{ display: 'none' }}
                                ref={el => this.fileInput = el}
                                onChange={e => {
                                    const file = e.target.files[0]
                                    if (file) this.importFromExcel(file)
                                }}
                            />
                            <Row style={{ marginBottom: '20px' }}>
                                <Col xs={12} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                    <Button
                                        type="default"
                                        icon={<DownloadOutlined />}
                                        onClick={this.exportToExcel}
                                    >
                                        Descargar Excel
                                    </Button>
                                    <Button
                                        type="default"
                                        icon={<DownloadOutlined />}
                                        onClick={this.downloadTemplate}
                                    >
                                        Descargar plantilla de importación
                                    </Button>
                                    <Button
                                        type="primary"
                                        icon={<UploadOutlined />}
                                        loading={importLoading}
                                        onClick={() => this.fileInput && this.fileInput.click()}
                                    >
                                        Importar Excel
                                    </Button>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={10} sm={6}>
                                    <Search ref={txt => this.searchInput = txt} style={{ marginBottom: '20px' }}
                                        placeholder="Nombre, correo electrónico o DNI del usuario"
                                        onSearch={(value) => this.searchUser(value)} enterButton />
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12}>
                                    {
                                        usersFiltered !== null && usersFiltered !== undefined ?
                                            this.renderUsersTable(usersFiltered)
                                            :
                                            <LoadingPage />
                                    }
                                </Col>
                            </Row>
                        </Grid>
                        :
                        this.getData()
                }
                <Modal
                    title={`Errores de importación (${importErrors.length})`}
                    visible={showErrorModal}
                    onOk={() => this.setState({ showErrorModal: false })}
                    onCancel={() => this.setState({ showErrorModal: false })}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    okText="Entendido"
                >
                    <List
                        size="small"
                        dataSource={importErrors}
                        renderItem={item => (
                            <List.Item>
                                <div>
                                    <strong>{item.name}</strong> — DNI: {item.dni}
                                    <br />
                                    <span style={{ color: '#ff4d4f' }}>{item.reason}</span>
                                </div>
                            </List.Item>
                        )}
                    />
                </Modal>
            </div>
        )
    }
}

Users.propTypes = {}

const mapStateToProps = state => ({
    user: getUser(state)
})

export default connect(mapStateToProps)(Users)

